/* eslint-disable */
import toast from '../../../services/toast';
import { mapGetters } from 'vuex';
import { Datetime } from 'vue-datetime';
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import { VueEditor } from "vue2-editor";
export default {
  name: 'public-add-quiz',
  components: {
    datetime: Datetime,
    VueEditor
  },
  props: [],
  data() {
    return {
      quizData: {
        name: '',
        category: '',
        instruction: '',
        quiz_number: '',
        time_limit:90,
        create_datetime:'',
        end_datetime:'',
        is_active:false,
        is_visible:false,
        testing_enabled:false
      },
      coursesCategory: {},
      submitted:false,
      courseDetais:'',
      pub_catID:'',
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold','italic','link',  '|', 'heading', 'fontFamily','fontSize','undo','redo']
      },
      instruction:'',
      code:''
    }
  },
  computed: {
    ...mapGetters([
      'getcourseCategoryState'
    ]),
    getCourseList() {
      return this.coursesCategory = this.$store.getters.getcourseCategoryState.data
    }
  },
  mounted() {
    this.pub_catID = this.$route.params.quiz_catId
  },
  methods: {
    clearEndTimePointFun(){
      this.quizData.end_datetime = ''
    },
    isActiveSwitchFun(){
      if(this.quizData.is_active === false){
        this.quizData.is_active = true
      }else if(this.quizData.is_active === true){
        this.quizData.is_active = false
      }
    },
    testingEnabledSwitchFun(){
      if(this.quizData.testing_enabled === false){
        this.quizData.testing_enabled = true
      }else if(this.quizData.testing_enabled === true){
        this.quizData.testing_enabled = false
      }
    },
    isVisibleSwitchFun(){
      if(this.quizData.is_visible === false){
        this.quizData.is_visible = true
      }else if(this.quizData.is_visible === true){
        this.quizData.is_visible = false
      }
    },
    validateCreateQuizBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            name: this.quizData.name,
            instruction: this.quizData.instruction,
            category: this.quizData.category,
            quiz_number:this.quizData.quiz_number,
            time_limit:this.quizData.time_limit,
            start_time:this.quizData.create_datetime,
            is_visible:this.quizData.is_visible,
            is_active:this.quizData.is_active,
            testing_enabled:this.quizData.testing_enabled,
            code:this.code
          }
          if(this.quizData.end_datetime != null && this.quizData.end_datetime != ''){
            data.end_time = this.quizData.end_datetime;
          }else{
            data.end_time = null
          }
          this.$store.dispatch('createQuizFun', data)
          .then((res) => {
            this.quizData.name = '',
            this.quizData.instruction = '',
            this.quizData.category = '',
            this.quizData.time_limit = '',
            this.quizData.create_datetime = '',
            this.quizData.end_datetime = '',
            this.quizData.is_visible = false
            this.quizData.is_active  = false,
            this.code = '',
            toast.success(res.data.msg);
            this.$validator.reset();
            this.$router.push('/course/contest/quizzes/category/' + this.pub_catID + '/list/' )
            })
            .catch((err) => {})
          return
        }
      });
    },
  },
  beforeMount() {
    this.getCourseList;
  },
  watch: {
    getCourseList() {
      return this.$store.getters.getcourseCategoryState.data
    }
  }
}